import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import { AuthService } from "./../services/auth.service";
import { BackendService } from "./../services/backend.service";
import * as firebase from "firebase/app";
import { Subject } from "rxjs/Subject";
import { Constants } from "../../helper/constants";

@Injectable()
export class AccountService {

  private authInstance: AngularFireAuth;
  private authState: firebase.User | null;
  private role;
  private userId: string;

  /**
   * @constructor
   * @param authService AuthService class
   * @param database AngularFireDatabase database reference
   * @param router Angular Router reference
   */
  constructor(private authService: AuthService, private database: AngularFireDatabase, private router: Router) {
    this.authInstance = this.authService.getAngularFireAuthInstance();
    this.authState = this.authService.getAuthState();
    if (this.authState) {
      this.userId = BackendService.generateUserId(this.authState.email);
    }
    this.role = new Subject();
  }

  /**
   *
   * @param {Array<{}>} roles
   * @returns {boolean}
   */
  canAccessAppResources(roles: Array<{}>): boolean {
    let status = false;
    if (roles) {
      const rolesBucket = roles.map((role: any) => role.role);

      status = rolesBucket.includes("Admin") || rolesBucket.includes("Community Manager");
    }

    return status;
  }

  /**
   *
   * @param userId
   * @returns {Observable<Array<{}>>}
   */
  getProfile(userId): Observable<{}> {
    const profile$ = this.database.object(`/profile/${userId}`).valueChanges();

    return profile$.map((data: any) => {
      if (data) {
        let communities = { ...data.communities };
        delete data.communities;
        const profile = data;

        profile.roles = [];
        if (profile && profile.isAdmin) {
          profile.roles.push({ role: Constants.USER_TYPE_ADMIN });
        }
        if (profile && communities) {
          communities = Object.values(communities);

          communities.forEach(community => {
            const communityName$ = this.database.object(`/communities/${community.id}/name`).valueChanges();
            if (community.roles) {
              const roles = Object.keys(community.roles);
              const notificationCount = community.notificationCount;
              roles.filter(role => role === Constants.USER_TYPE_ADMIN || role === Constants.USER_TYPE_COMMUNITY_MANAGER)
                .forEach(role => {
                    const unreadNotificationsCount = notificationCount ? notificationCount[role] : 0;
                    profile.roles.push({ communityId: community.id, role, unreadNotificationsCount });
                });
            }
          });
        }

        return profile;
      } else {
        return undefined;
      }
    });
  }

  async getActiveRoleDetails(): Promise<object> {
    const activeRouteIndex = this.generateActiveRouteIndex();

    return await new Promise<any>(resolve => {
      this.getProfile(this.userId).subscribe((profile: any) => {

        if (profile.roles.length > 0) {
        profile.roles[activeRouteIndex]["index"] = activeRouteIndex;
        }
        resolve(profile.roles[activeRouteIndex]);
      });
    });
  }

  generateActiveRouteIndex(): number {
    const activeRouteIndex = this.router.url.indexOf("/r/") + 3;

    return parseInt(this.router.url.charAt(activeRouteIndex), 10);
  }

  setUserId(userId): void {
    this.userId = userId;
  }

  getUserId(): string {
    return this.userId;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/account/account.service.ts